module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-25@2x-2ef263807947784c0a79ffab4503f5d2.png";